"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const ExpandLess_1 = __importDefault(require("@mui/icons-material/ExpandLess"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const MenuField = ({ attributes, callbacks, SHOW_ALL, fieldActive, txn, showSplitsAndDetails, field, fieldIsEditable, focusField, }) => {
    const { classes } = useStyles();
    return (<styles_1.RegListItem {...attributes} tabIndex={null} className={classes.iconButtonColumn} onClick={null}>
      {SHOW_ALL && fieldIsEditable(field) && (<QIconButton_1.default autoFocus={fieldActive} aria-label={!showSplitsAndDetails ? 'Show details' : 'Hide details'} ref={fieldActive ? (input) => {
                focusField.current = input; // eslint-disable-line
            } : null} focusRipple IconComponent={!showSplitsAndDetails ? ExpandMore_1.default : ExpandLess_1.default} onClick={() => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, showSplitsAndDetails ? 'hideDetails' : 'showDetails', txn); }} size="small-target"/>)}
    </styles_1.RegListItem>);
};
exports.default = MenuField;
